<template>
  <section
    :class="[
      'shop',
      isPremiumMonthlyPromoActive && 'shop--premium-promo-banner',
      isEDAPremiumPreSaleActive && 'shop--eda-premium-pre-sale-banner',
    ]"
  >
    <div class="shop__content">
      <div class="shop__content-subscriptions">
        <SubscriptionsListSection />
      </div>
      <template v-if="!isOnePlanAvailable">
        <div v-if="!isSubscriptionsTeamsSelected" class="shop__content-skill-dive">
          <SkillDiveSection />
        </div>
        <div
          v-if="!userHasSubscription && !isSubscriptionsTeamsSelected"
          class="shop__content-bundles"
        >
          <BundlesListSection @update-selected-plan="updateSelectedPlan" />
        </div>
      </template>
      <div v-if="!isOnePlanAvailable" class="shop__content-certifications">
        <CertificationsList />
      </div>
    </div>
    <div v-if="!isOnePlanAvailable" class="shop__content-live-virtual-training">
      <LiveVirtualTrainingSection />
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import CertificationsList from '@/components/certifications/CertificationsList.vue'
import SubscriptionsListSection from '@/components/shop-sections/SubscriptionsList.vue'
import BundlesListSection from '@/components/shop-sections/BundlesList.vue'
import LiveVirtualTrainingSection from '@/components/shop-sections/LiveVirtualTrainingSection.vue'
import SkillDiveSection from '@/components/shop-sections/SkillDiveSection.vue'
import { updateCart, promoProductBundleUtils } from '@/helpers/mixins'

export default {
  name: 'Shop',
  components: {
    CertificationsList,
    LiveVirtualTrainingSection,
    SubscriptionsListSection,
    BundlesListSection,
    SkillDiveSection,
  },
  mixins: [updateCart, promoProductBundleUtils],
  computed: {
    ...mapState({
      shoppingCart: state => state.shoppingCart.shoppingCart,
      isOnePlanAvailable: state => state.products.isOnePlanAvailable,
      isPremiumMonthlyPromoActive: state => state.app.isPremiumMonthlyPromoActive,
      isEDAPremiumPreSaleActive: state => state.app.isEDAPremiumPreSaleActive,
      usersCurrentSubscriptions: state => state.subscriptions.usersCurrentSubscriptions,
      isSubscriptionsTeamsSelected: state => state.app.isSubscriptionsTeamsSelected,
    }),
    userHasSubscription() {
      return this.usersCurrentSubscriptions.length > 0
    },
  },
  created() {
    this.setIsPromotionActive()
    if (this.isPromotionActive && this.promoBundlesOnCart) {
      this.clearCart()
    }
  },
}
</script>

<style lang="scss" scoped>
.shop {
  width: 100%;
  max-width: 1120px;
  margin: auto;
  margin-top: 20px;
  color: var(--white);
  font-family: var(--font-regular);
  @media screen and (max-width: 1236px) {
    padding: 20px;
    margin-bottom: 115px;
  }
  @include mobile {
    margin-bottom: 85px;
  }
  @include tablet-ipad-pro {
    margin-bottom: 115px;
  }
  @include desktop {
    margin-bottom: 135px;
  }
  &--eda-premium-pre-sale-banner,
  &--premium-promo-banner {
    padding-top: 0;
    margin-top: 0;
    z-index: 1;
    @include desktop {
      margin-top: auto;
    }
  }
  &__free-trial-banner {
    margin-bottom: 30px;
  }
  &__content {
    &-certifications {
      border-top: 1px solid var(--mid-gray-translucid);
      margin-top: 90px;
      @include lg-desktop {
        margin-bottom: 5%;
      }
      .certifications-list {
        margin-top: 50px;
      }
    }
    &-skill-dive,
    &-bundles {
      border-top: 1px solid var(--mid-gray-translucid);
      .bundles-list {
        margin-top: 50px;
      }
    }
    &-subscriptions {
      margin-bottom: 60px;
    }
  }
  &__els-link {
    margin-top: 65px;
    margin-bottom: 60px;
    @include mobile {
      margin-top: 95px;
      margin-bottom: 90px;
    }
    @include desktop {
      margin-top: 95px;
      margin-bottom: 100px;
    }
  }
}
</style>
